var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgencyNameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.399,
    viewBox: "0 0 24 19.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-tag-solid_1_",
    "data-name": "user-tag-solid (1)",
    d: "M8.487,9.7a4.85,4.85,0,1,0-4.85-4.85A4.85,4.85,0,0,0,8.487,9.7ZM6.756,11.518A6.754,6.754,0,0,0,0,18.274,1.125,1.125,0,0,0,1.125,19.4H15.849a1.12,1.12,0,0,0,.917-.474l-3.759-3.759a3.009,3.009,0,0,1-.883-2.126v-1.25a6.717,6.717,0,0,0-1.906-.273H6.756Zm7.794-3.031A1.211,1.211,0,0,0,13.337,9.7v3.133a2.426,2.426,0,0,0,.709,1.716l4.069,4.066a1.823,1.823,0,0,0,2.573,0l2.781-2.781a1.823,1.823,0,0,0,0-2.573L19.4,9.2a2.426,2.426,0,0,0-1.716-.709Zm.909,3.031a.909.909,0,1,1,.909.909A.909.909,0,0,1,15.459,11.518Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyNameIcon);
export default __webpack_public_path__ + "static/media/agency-name-icon.7d6b0ace467a5b423fd8640fecfb6aa0.svg";
export { ForwardRef as ReactComponent };